import {
  GridToolbarColumnsButton,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid-premium';
import React from 'react';
import ExportCommands from './ExportCommands';

const GridControls = () => {
  return (
    <div className="flex w-full gap-4 px-2">
      <GridToolbarColumnsButton />
      <ExportCommands />
      <GridToolbarQuickFilter />
    </div>
  );
};

export default GridControls;
